// Plain data so surfaces like the cancellation flow can reuse the same promise without importing the component.
export const promotionCopy = {
  analytics: {
    title: "Ask questions your dashboard was never built for",
    description:
      "Compare revenue, conversion, products, pages, and traffic sources with a plain-English request.",
    gradient:
      "bg-gradient-to-r from-sheet via-cyan-soft to-violet-soft md:flex-row",
  },
  pages: {
    title: "Introducing the new version of Replo",
    description: null,
    gradient:
      "bg-gradient-to-r from-sheet via-brand-yellow/30 to-brand-light-pink/60 md:flex-row",
  },
  billing: {
    title: "Build products, checkout, and fulfillment too",
    description:
      "Create products, connect Stripe checkout, send paid merch orders to Printful, and analyze what sold.",
    gradient:
      "bg-gradient-to-r from-sheet via-orange-soft to-pink-soft md:flex-row",
  },
  sidebar: {
    title: "Research the market before you build",
    description:
      "Study competitors, keywords, reviews, and search results. Then turn the findings into a site.",
    gradient: "bg-gradient-to-br from-sheet via-violet-soft to-cyan-soft",
  },
  experiments: {
    title: "Turn the winning ad into its landing page",
    description:
      "Read Meta performance, pull the winning creative, and build a matching page in the same conversation.",
    gradient:
      "bg-gradient-to-r from-sheet via-violet-soft to-pink-soft md:flex-row",
  },
} as const;
